import React, {useState, createContext} from 'react'

export const NFOContext = createContext()

export const NFOContextProvider = (props) => {
    const[NFOData, setNFOData] = useState(null)
    return (
        <NFOContext.Provider value={[NFOData,setNFOData]}>
            {props.children}
        </NFOContext.Provider>
    )
}